import React from 'react'

import { GetCustomerOrdersQuery } from '../../../../graphql/camel'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import EmptyHistory from '../EmptyHistory'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import LoadMore from '../LoadMore'
import ReorderItems from './ReorderItems'

export interface ReorderItemsPageContentProps {
  data: GetCustomerOrdersQuery | undefined
  loading: boolean
  onLoadMore: (() => Promise<unknown>) | undefined
}

const ReorderItemsPageContent: React.VFC<ReorderItemsPageContentProps> = ({
  data,
  loading,
  onLoadMore,
}) => {
  const anyOrdersPresent = !!data?.getCustomerOrders?.orders?.length

  return (
    <div>
      <HeaderWithSecondaryButton
        buttonHidden
        buttonText=""
        headerText="Reorder Items"
        onClick={() => false}
      />
      <Spacer size={3} />
      {anyOrdersPresent ? (
        <div>
          <ReorderItems showFrequentItems={true} showRecentItems={true} />
          {onLoadMore && (
            <LoadMore buttonText="Load more" loading={loading} onLoadMore={onLoadMore} />
          )}
        </div>
      ) : loading ? (
        <Spinner loading />
      ) : (
        <EmptyHistory message="No order history at the moment." />
      )}
    </div>
  )
}

export default ReorderItemsPageContent
